import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '../../utils/userStorage';

export const api = createApi({
	reducerPath: 'authAPI',
	baseQuery: fetchBaseQuery({
		baseUrl: `${import.meta.env.VITE_APP_ACCOUNT_API_URL}`,
		prepareHeaders: headers => {
			const accessToken = getAccessToken();

			headers.set('content-type', 'application/json');
			if (accessToken) {
				headers.set('authorization', `Bearer ${accessToken}`);
			}
			return headers;
		}
	}),
	endpoints: builder => ({
		login: builder.mutation({
			query: data => ({
				url: '/login/',
				method: 'POST',
				body: data
			})
		}),
		updatePassword: builder.mutation({
			query: payload => ({
				url: `/updatePassword/`,
				method: 'PATCH',
				body: payload
			})
		}),
		oAuthLogin: builder.mutation({
			query: data => ({
				url: '/o/authorize/',
				method: 'POST',
				headers: {
					'content-type': 'application/xxx-www-form-urlencoded'
				},
				body: data
			})
		})
	})
});

export const {
	useUpdatePasswordMutation,
	useLoginMutation,
	useOAuthLoginMutation
} = api;
